/**
 * Which episode the series hero should offer.
 *
 * Listing order is the wrong answer, and it was the one in use: walking the
 * flattened episode list and stopping at the first stored position offers the
 * OLDEST unfinished episode. Start S01E02, abandon it, watch up to S01E05, and
 * the hero button sends you back to E02. "Where was I" means the most recent
 * one, which is what `updatedAt` records.
 */

import type { SeriesEpisode } from './api';

export interface EpisodeProgress {
  positionS: number;
  durationS: number;
  /** When the viewer last touched it. */
  updatedAt: number;
}

export interface NextUp {
  episode: SeriesEpisode;
  /** False when nothing has been watched and this is simply the first episode. */
  resume: boolean;
}

export function findNextUp(episodes: SeriesEpisode[], progress: Map<string, EpisodeProgress>): NextUp | null {
  if (!episodes.length) return null;

  let best: { episode: SeriesEpisode; at: number } | null = null;
  for (const episode of episodes) {
    const entry = progress.get(episode.id);
    if (!entry) continue;
    if (!best || entry.updatedAt > best.at) best = { episode, at: entry.updatedAt };
  }

  if (best) return { episode: best.episode, resume: true };
  return { episode: episodes[0], resume: false };
}
